<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>基础信息</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->


    <el-card>
      <div>
      </div>
      <el-alert
        title="部门信息: 当存在不同部门不同薪资模板时,可使用区分当月不同模板工资表"
        type="warning"
        center
        show-icon>
      </el-alert>
    </el-card>

    <el-card>
      <!-- 搜索 添加 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入内容" v-model="queryInfo.departmentName" clearable @clear="getUserList">     <!-- clearable可清空搜索数据之后返回整体的菜单 -->
            <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisible = true">添加部门</el-button>
        </el-col>
      </el-row>


      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="departmentName" label="部门名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
<!--        <el-table-column  label="状态">-->
<!--          <template slot-scope="scope">-->
<!--            <el-switch-->
<!--              v-model="scope.row.mg_state" @change="userStateChanged(scope.row)">-->
<!--            </el-switch>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column  label="操作" width="185px">
           <template slot-scope="scope">
             <!-- 修改按钮 -->
           <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.departmentId)"></el-button>
           <!-- 删除按钮 -->
           <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.departmentId)"></el-button>
           </template>
        </el-table-column>
      </el-table>
    <!-- 分页区域 -->
     <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[20]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!-- 添加用户对话框 -->
        <el-dialog
          title="添加部门"
          :visible.sync="addDialogVisible"
          width="50%"
          @close="addDialogClosed">
          <!--  内容主体区域-->
          <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="120px" >
            <el-form-item label="部门名称" prop="departmentName">
              <el-input v-model="addForm.departmentName"></el-input>
            </el-form-item>
            </el-form>
          <!--底部区域  -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addUser">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 修改用户的对话框 -->
        <el-dialog
              title="修改部门"
              :visible.sync="editDialogVisible"
              width="50%"
              @close="editDialogClosed"
            >
              <!-- 内容主体 -->
              <el-form
                :model="editForm"
                ref="editFormRef"
                :rules="editFormRules"
                label-width="70px"
              >
                <el-form-item label="部门名称">
                  <el-input v-model="editForm.departmentName"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editUserInfo">确 定</el-button>
              </span>
            </el-dialog>
    </el-card>
 </div>
</template>

<script>
export default {
  data () {
     // 自定义邮箱规则
        var checkEmail = (rule, value, callback) => {
          const regEmail = /^\w+@\w+(\.\w+)+$/
          if (regEmail.test(value)) {
            // 合法邮箱
            return callback()
          }
           // 返回一个错误提示
          callback(new Error('请输入合法邮箱'))
        }
        // 自定义手机号规则
        var checkMobile = (rule, value, callback) => {
          const regMobile = /^1[34578]\d{9}$/
          if (regMobile.test(value)) {
            return callback()
          }
          // 返回一个错误提示
          callback(new Error('请输入合法的手机号码'))
        }
    return {
      //获取用户列表的参数对象
      queryInfo: {
        departmentName: '',
        //当前的页数
        page: 1,
        //当前每页显示多少条数据
        limit: 20
      },
      userlist: [],
      total: 0,
      //控制添加用户对话框的显示与隐藏
      addDialogVisible:false,
      //添加用户表单数据
      addForm: {
        departmentName: ''
      },
      //添加表单的验证规则对象
      addFormRules: {
        departmentName: [
          { required: true, message: '请输入部门名称', trigger: 'blur'  },//失去焦点时触发验证时机
                   {
                     min: 1,
                     max: 10,
                     message: '部门名称的长度在1～10个字',
                     trigger: 'blur'
                   }
        ]
      },
      //控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      //查询到的用户信息对象
      editForm: {},
      //修改表单的验证规则对象
      // 编辑用户表单验证
       editFormRules: {
             email: [
               { required: true, message: '请输入用户邮箱', trigger: 'blur' },
               { validator: checkEmail, trigger: 'blur' }
             ],
             mobile: [
               { required: true, message: '请输入用户手机号码', trigger: 'blur' },
               { validator: checkMobile, trigger: 'blur' }
             ]
        },
        //控制分配角色对话框的显示与隐藏
        setRoleDialogVisible: false,
        //需要被分配角色的用户信息
        userInfo: {},
        //所有角色的数据列表
        rolesLsit: [],
        //已选中的ID值
        selectedRoleId: ''
      }
  },
  created () {
    this.getUserList()
  },
  methods: {
  async getUserList(){
     const { data: res } = await this.$http.get('department/v2/queryDepartmentPageList',{
       params: this.queryInfo,
       })   //get参数用params获得
       if(res.code !== '10000') {
         return this.$message.error(res.msg)
       }
       this.userlist = res.data.list;
       this.total = res.data.count
       console.log(res)
  },
    // 监听pagesize 改变的事件
  handleSizeChange(newSize) {
    // console.log(newSize)
    this.queryInfo.limit = newSize
    this.getUserList()
  },
  // 监听页码值改变的事件
  handleCurrentChange(newPage) {
    // console.log(newPage)
    this.queryInfo.page = newPage
    this.getUserList()
  },
  //监听switch开关状态的改变
    async userStateChanged(userinfo) {
      // console.log(userinfo)
    const {data: res} =  await this.$http.put(`users/${userinfo.id}/state/${userinfo.mg_state}`)
    if(res.meta.status !== 200){
      userinfo.mg_state = !userinfo.mg_state   //如果更新是失败，取反
      return this.$message.error('更新用户状态失败！')
    }
    this.$message.success('更新用户状态成功！')
    },
    //监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    //点击按钮，添加新用户
    addUser() {
      this.$refs.addFormRef.validate(async valid => {
        // console.log(valid)
        if(!valid) return
        //可以发起用户的网络请求
        const {data: res} = await this.$http.post('/department/addDepartment',this.addForm)

        if(res.code != '10000'){
           this.$message.error(res.msg)
        }
          this.$message.success('添加部门成功!')
          //隐藏添加用户的对话框
          this.addDialogVisible = false
          //重新获取列表数据
          this.getUserList()
      })
    },
    //展示编辑用户的对话框
    async showEditDialog(id) {
      const {data: res} =  await this.$http.get('/department/v2/findInfo?departmentId=' + id)

      if(res.code !== '10000'){
        return this.$message.error(res.msg)
      }

       this.editForm = res.data    //对数据进行保存
      this.editDialogVisible = true
    },
    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.$refs.editFormRef.resetFields()
      },
      //修改用户信息并提交
      editUserInfo() {
        // 提交请求前，表单预验证
             this.$refs.editFormRef.validate(async valid => {
               // console.log(valid)
               // 表单预校验失败
               if (!valid) return
               const { data: res } = await this.$http.post(
                 '/department/updateDepartment/',
                 {
                   departmentId:this.editForm.departmentId,
                   departmentName: this.editForm.departmentName
                 }
               )
               if (res.code !== '10000') {
                 this.$message.error(res.msg)
               }
               // 隐藏添加用户对话框
               this.editDialogVisible = false
               this.$message.success('更新信息成功！')
               this.getUserList()
             })
  },
  //根据id删除对应信息
  async removeUserById (id) {
        const confirmResult = await this.$confirm(            //promise  用await
          '此操作将永久删除该用户, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch(err => err)
        // 点击确定 返回值为：confirm
        // 点击取消 返回值为： cancel
        if (confirmResult !== 'confirm') {
          return this.$message.info('已取消删除')
        }

        let ids = [];
        ids.push(id);

        const { data: res } = await this.$http.post('/department/deleteDepartment/', {
          ids:ids
        })

        if (res.code !== '10000') return this.$message.error('删除失败！')
        this.$message.success('删除成功！')
        this.getUserList()
  }
  }
}

</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/department/Department.vue